import Section from "@/components/Section";
import teamCollaboration from "@/assets/team-collaboration.png";
import responsibleAI from "@/assets/responsible-ai.png";

const OurStory = () => {
  return (
    <>
      {/* Section 1: Who We Are */}
      <Section
        eyebrow="Who we are"
        title={<>Our <span className="text-gradient-brand">Story</span></>}
        description="A senior network of experts in AI, digital transformation, ethics, and law."
      >
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="space-y-4 text-muted-foreground text-lg leading-relaxed">
            <p>
              AI-labbet is a network of senior experts in AI, digital transformation, ethics, and law. We work with executive teams and decision-makers to design and execute strategies that create business value through responsible AI.
            </p>
            <p>
              As a network organization, we work without rigid hierarchies or silos. We form dynamic, cross-functional project teams that bring together the right expertise for each challenge, in a flexible and effective way. This structure allows us to adapt quickly to new trends and deliver tailored AI solutions that fit each client's goals and context.
            </p>
          </div>

          <div className="relative">
            <div className="absolute -inset-2 bg-gradient-brand opacity-20 blur-2xl rounded-2xl" aria-hidden />
            <img
              src={teamCollaboration}
              alt="Team collaborating in futuristic office with AI dashboards"
              className="relative w-full h-full object-cover rounded-2xl border border-border/60"
            />
          </div>
        </div>
      </Section>

      {/* Section 2: Our Approach */}
      <Section
        surface="alt"
        eyebrow="Our approach"
        title={<>Co-creating your <span className="text-gradient-brand">AI future</span></>}
        description="We are partners shaping the next chapter of your business — not advisors on the sidelines."
      >
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative order-2 md:order-1">
            <div className="absolute -inset-2 bg-gradient-brand opacity-20 blur-2xl rounded-2xl" aria-hidden />
            <img
              src={responsibleAI}
              alt="Responsible use of AI - robot and human collaboration with scales of justice"
              className="relative w-full h-full object-cover rounded-2xl border border-border/60"
            />
          </div>

          <div className="space-y-4 text-muted-foreground text-lg leading-relaxed order-1 md:order-2">
            <p>
              We are more than consultants, we are co-creators of your AI future. At AI-labbet, we believe innovation happens when vision and technology meet in true collaboration. That's why we work side by side with you, not as advisors on the sidelines, but as partners shaping the next chapter of your business. Our approach is deeply strategic: we start by understanding your ambitions, challenges, and opportunities. Together, we design AI solutions that reflect your values and accelerate your goals. We are independent, objective, and fearless in challenging assumptions or pushing the boundaries of what AI can achieve.
            </p>
            <p>
              Our mission is to create positive impact through AI for both business and society. We are deeply committed to ensuring AI is used <span className="font-semibold text-foreground">responsibly, transparently, and ethically</span>. By staying at the forefront of global AI developments and regulations, we help our clients stay compliant and ready for the future.
            </p>
            <p>
              Whether you are just in the beginning of your AI journey or looking to scale your capabilities, we are here to help you unlock the full potential of AI.
            </p>
          </div>
        </div>
      </Section>
    </>
  );
};

export default OurStory;
